import React from 'react';
import { useContext, useState } from 'react';
import { InputContext } from '../components/InputContext';
import { useNavigate } from 'react-router-dom';

function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const { username, admin } = useContext(InputContext);
  const { signOut } = useContext(InputContext);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
    console.log(admin);
  };

  const handleAccount = () => {
    console.log('Go to User Account');
    navigate('/profile');
  };

  const handleSignOut = () => {
    console.log('Signing out');
    signOut(); 
    navigate('/'); 
  };

  const handleAdmin = () => {
    navigate('/admin');
  }

  return (
    <div className="user-dropdown">
      <button onClick={toggleDropdown} className="user-id">
        {username} ▼
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          <button onClick={handleAccount}>User Profile</button>
          <button onClick={handleSignOut}>Sign Out</button>
          {admin && <button onClick={handleAdmin}>Admin View</button>}
        </div>
      )}
    </div>
  );
}

export default UserDropdown;